import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { NotificationViewDto } from "./getUserNotifications";
import { NotificationQueryParams } from "./updateAllNotificationsAsViewed";

export type NotificationViewReturn = IAxiosReturn<NotificationViewDto>;

/**
 * Updates the notification status to viewed or not viewed.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param notification - The notification object with updated status
 * @param controller - Optional AbortController for cancelling the request
 * @returns Promise<NotificationViewReturn>
 */
export const updateNotificationStatus = async (
  backEndUrl: string,
  notification: NotificationQueryParams,
  controller?: AbortController,
): Promise<NotificationViewReturn> => {
  // Send data
  try {
    const url = `${backEndUrl}Comments/ToggleNotificationViewedStatus/${notification.notificationId}`;
    const response: { data: NotificationViewDto } = await axios.put(
      url,
      controller ? { signal: controller.signal } : undefined,
    );
    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("update notification status failed", error);
  }
};
